import { INDUSTRIES, INDUSTRY_ICONS, INDUSTRY_LABEL_MAX_LENGTH, type IndustryKey } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { Field, Icon, Input, RadioGroup } from "@sagot/ui";

interface IndustryPickerProps {
  value: IndustryKey | null;
  onChange: (industry: IndustryKey) => void;
  label: string;
  onLabelChange: (label: string) => void;
  error?: string;
  labelError?: string;
}

/** Step 1, first question: industry cards (+ free-text industry for "Other"). */
export function IndustryPicker({ value, onChange, label, onLabelChange, error, labelError }: IndustryPickerProps) {
  const { t } = useTranslation();
  const options = INDUSTRIES.map((industry) => ({
    value: industry,
    label: (
      <span className="inline-flex items-center gap-2">
        <Icon name={INDUSTRY_ICONS[industry]} className="size-4 text-primary-ink" />
        {t(`onboarding.industries.${industry}`)}
      </span>
    ),
  }));
  return (
    <fieldset className="space-y-3" data-testid="industry-picker">
      <legend id="industry-legend" className="text-base font-bold">
        {t("onboarding.org.industry")}
      </legend>
      <RadioGroup<IndustryKey | "">
        aria-labelledby="industry-legend"
        variant="cards"
        className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
        options={options}
        value={value ?? ""}
        onValueChange={(next) => { if (next) onChange(next); }}
      />
      {error ? (
        <p className="text-xs font-semibold text-danger" role="alert">
          {error}
        </p>
      ) : null}
      {value === "other" ? (
        <Field label={t("onboarding.org.industryOther")} hint={t("onboarding.org.industryOtherHint")} error={labelError} className="max-w-md">
          <Input value={label} maxLength={INDUSTRY_LABEL_MAX_LENGTH} onChange={(event) => { onLabelChange(event.target.value); }} />
        </Field>
      ) : null}
    </fieldset>
  );
}
